import { useState } from "react";

interface FormState {
  nome: string;
  email: string;
  telefone: string;
  servico: string;
  mensagem: string;
}

const FORM_URL = "https://readdy.ai/api/form/d6v2fot1l1ubpb129ba0";

export default function ContactSection() {
  const [form, setForm] = useState<FormState>({
    nome: "",
    email: "",
    telefone: "",
    servico: "",
    mensagem: "",
  });
  const [status, setStatus] = useState<"idle" | "sending" | "success" | "error">("idle");

  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>
  ) => {
    setForm((prev) => ({ ...prev, [e.target.name]: e.target.value }));
  };

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    if (form.mensagem.length > 500) {
      setStatus("error");
      return;
    }
    setStatus("sending");
    try {
      const body = new URLSearchParams();
      Object.entries(form).forEach(([k, v]) => body.append(k, v));
      const res = await fetch(FORM_URL, { method: "POST", body, headers: { "Content-Type": "application/x-www-form-urlencoded" } });
      if (res.ok) {
        setStatus("success");
        setForm({ nome: "", email: "", telefone: "", servico: "", mensagem: "" });
      } else {
        setStatus("error");
      }
    } catch {
      setStatus("error");
    }
  };

  return (
    <section id="contato" className="py-16 md:py-24 bg-white">
      <div className="max-w-6xl mx-auto px-4 md:px-6">
        {/* Final CTA Banner */}
        <div className="bg-gradient-to-r from-secondary to-secondary-500 rounded-2xl p-6 md:p-10 text-center mb-12 md:mb-16">
          <h3 className="text-xl md:text-4xl font-extrabold text-white mb-3 md:mb-4">
            Seu sorriso começa hoje
          </h3>
          <p className="text-white/85 text-sm md:text-base max-w-xl mx-auto mb-6 md:mb-8">
            Não deixe para depois. Venha avaliar seu sorriso gratuitamente e saiba em minutos como começar seu tratamento com parcelamento acessível.
          </p>
          <a
            href="https://wa.me/5511999999999?text=Ol%C3%A1%2C%20quero%20agendar%20minha%20avalia%C3%A7%C3%A3o%20gratuita%20na%20Primor%20Odontologia!"
            target="_blank"
            rel="nofollow noreferrer"
            className="inline-flex items-center justify-center gap-3 bg-white text-secondary font-bold px-6 md:px-8 py-3 md:py-4 rounded-full text-sm md:text-base hover:bg-white/90 transition-colors cursor-pointer w-full sm:w-auto"
          >
            <i className="ri-whatsapp-line text-xl"></i>
            Agendar Avaliação Gratuita
          </a>
        </div>

        <div className="grid md:grid-cols-2 gap-8 md:gap-12">
          {/* Left: Info + Map */}
          <div>
            <span className="text-secondary font-semibold text-sm uppercase tracking-widest">Localização</span>
            <h3 className="text-2xl font-extrabold text-primary-700 mt-3 mb-6">Venha nos visitar</h3>

            <div className="space-y-4 mb-8">
              {[
                { icon: "ri-map-pin-line", label: "Endereço", value: "Avenida Aratãs 568, São Paulo – SP" },
                { icon: "ri-time-line", label: "Horário", value: "Seg–Sex: 08h–20h  |  Sáb: 08h–14h" },
                { icon: "ri-whatsapp-line", label: "WhatsApp", value: "(11) 91983-0222" },
                { icon: "ri-phone-line", label: "Telefone", value: "(11) 91983-0222" },
              ].map((info) => (
                <div key={info.label} className="flex items-center gap-4">
                  <div className="w-10 h-10 flex items-center justify-center bg-primary-50 rounded-xl text-primary-700 flex-shrink-0">
                    <i className={`${info.icon} text-lg`}></i>
                  </div>
                  <div>
                    <p className="text-xs text-gray-400 font-semibold uppercase tracking-wider">{info.label}</p>
                    <p className="text-primary-700 font-semibold text-sm">{info.value}</p>
                  </div>
                </div>
              ))}
            </div>

            {/* Map */}
            <div className="rounded-2xl overflow-hidden border border-gray-100" style={{ height: "240px" }}>
              <iframe
                title="Localização Primor Odontologia"
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3654.0!2d-46.6558!3d-23.5913!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2sAvenida+Arat%C3%A3s+568%2C+S%C3%A3o+Paulo!5e0!3m2!1spt-BR!2sbr!4v1680000000000!5m2!1spt-BR!2sbr"
                width="100%"
                height="100%"
                style={{ border: 0 }}
                allowFullScreen
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
              ></iframe>
            </div>
          </div>

          {/* Right: Form */}
          <div className="bg-primary-50 rounded-2xl p-5 md:p-8">
            <h4 className="text-xl font-extrabold text-primary-700 mb-2">Agendar Consulta</h4>
            <p className="text-gray-500 text-sm mb-6">Preencha o formulário e entraremos em contato rapidamente.</p>

            {status === "success" ? (
              <div className="text-center py-12">
                <div className="w-16 h-16 flex items-center justify-center bg-secondary/10 rounded-full mx-auto mb-4 text-secondary text-3xl">
                  <i className="ri-checkbox-circle-line"></i>
                </div>
                <p className="text-primary-700 font-bold text-lg">Solicitação enviada!</p>
                <p className="text-gray-500 text-sm mt-2">Nossa equipe entrará em contato em breve. Você também pode nos chamar no WhatsApp!</p>
                <button onClick={() => setStatus("idle")} className="mt-6 text-secondary font-semibold text-sm cursor-pointer">
                  Enviar outro
                </button>
              </div>
            ) : (
              <form data-readdy-form onSubmit={handleSubmit} className="space-y-4">
                <div>
                  <label className="block text-xs font-semibold text-gray-500 mb-1 uppercase tracking-wide">Nome completo</label>
                  <input
                    type="text"
                    name="nome"
                    value={form.nome}
                    onChange={handleChange}
                    required
                    placeholder="Seu nome"
                    className="w-full border border-gray-200 bg-white rounded-xl px-4 py-3 text-sm text-primary-700 placeholder-gray-400 focus:outline-none focus:border-primary-400"
                  />
                </div>
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                  <div>
                    <label className="block text-xs font-semibold text-gray-500 mb-1 uppercase tracking-wide">E-mail</label>
                    <input
                      type="email"
                      name="email"
                      value={form.email}
                      onChange={handleChange}
                      required
                      placeholder="seu@email.com"
                      className="w-full border border-gray-200 bg-white rounded-xl px-4 py-3 text-sm text-primary-700 placeholder-gray-400 focus:outline-none focus:border-primary-400"
                    />
                  </div>
                  <div>
                    <label className="block text-xs font-semibold text-gray-500 mb-1 uppercase tracking-wide">Telefone</label>
                    <input
                      type="tel"
                      name="telefone"
                      value={form.telefone}
                      onChange={handleChange}
                      required
                      placeholder="(11) 99999-9999"
                      className="w-full border border-gray-200 bg-white rounded-xl px-4 py-3 text-sm text-primary-700 placeholder-gray-400 focus:outline-none focus:border-primary-400"
                    />
                  </div>
                </div>
                <div>
                  <label className="block text-xs font-semibold text-gray-500 mb-1 uppercase tracking-wide">Serviço desejado</label>
                  <select
                    name="servico"
                    value={form.servico}
                    onChange={handleChange}
                    required
                    className="w-full border border-gray-200 bg-white rounded-xl px-4 py-3 text-sm text-primary-700 focus:outline-none focus:border-primary-400"
                  >
                    <option value="">Selecione um serviço</option>
                    <option>Avaliação Gratuita</option>
                    <option>Limpeza e Prevenção</option>
                    <option>Extração</option>
                    <option>Restauração</option>
                    <option>Prótese Dentária</option>
                    <option>Clareamento Dental</option>
                    <option>Urgência / Emergência</option>
                  </select>
                </div>
                <div>
                  <label className="block text-xs font-semibold text-gray-500 mb-1 uppercase tracking-wide">
                    Mensagem <span className="text-gray-400 normal-case">(max. 500 caracteres)</span>
                  </label>
                  <textarea
                    name="mensagem"
                    value={form.mensagem}
                    onChange={handleChange}
                    maxLength={500}
                    rows={3}
                    placeholder="Conte um pouco sobre o que precisa..."
                    className="w-full border border-gray-200 bg-white rounded-xl px-4 py-3 text-sm text-primary-700 placeholder-gray-400 focus:outline-none focus:border-primary-400 resize-none"
                  />
                  <p className="text-xs text-gray-400 text-right">{form.mensagem.length}/500</p>
                </div>

                {status === "error" && (
                  <p className="text-red-500 text-xs">Ocorreu um erro. Por favor, tente novamente ou entre em contato pelo WhatsApp.</p>
                )}

                <button
                  type="submit"
                  disabled={status === "sending"}
                  className="w-full bg-primary-700 hover:bg-primary-800 disabled:opacity-60 text-white font-bold py-3.5 rounded-xl transition-colors cursor-pointer whitespace-nowrap text-sm"
                >
                  {status === "sending" ? "Enviando..." : "Enviar solicitação"}
                </button>

                <p className="text-center text-xs text-gray-400">
                  Ou fale agora pelo{" "}
                  <a
                    href="https://wa.me/5511999999999"
                    target="_blank"
                    rel="nofollow noreferrer"
                    className="text-secondary font-semibold cursor-pointer"
                  >
                    WhatsApp
                  </a>
                </p>
              </form>
            )}
          </div>
        </div>
      </div>
    </section>
  );
}
